import { Link } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { EshopSettingsForm } from '@/forms/EshopSettingsForm/EshopSettingsForm'
import { Settings } from '@/interfaces/Settings'

export default function SettingsEshopPage() {
  const { data: settings, isLoading, mutate } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Nastavení e-shopu"
      description={
        <>
          Obecná pravidla košíku a objednávek. Dopravu, platby, odběrná místa a tokeny spravujete v sekci{' '}
          <Link to="/eshop/delivery-methods" className="text-link hover:underline">
            E-shop
          </Link>
          .
        </>
      }
      breadcrumbHref="/settings/eshop"
    >
      {isLoading && <Loading />}

      {settings && (
        <EshopSettingsForm
          defaultValues={{
            eshopPriceMode: settings.eshopPriceMode,
            addressRequirement: settings.addressRequirement,
          }}
          onSuccess={() => mutate()}
        />
      )}
    </SettingsPage>
  )
}
